module.exports = __webpack_public_path__ + "static/media/206-Telefonat_ID_13.c765ca0b.mp3";